import { ref, readonly } from 'vue';

import { SurveyType } from '@/types/request';

const _isVisibleModalSurvey = ref(false); // 모달 보임 여부
const _typeSurvey = ref<SurveyType>('DELETE_ACCOUNT'); // 설문조사 종류

export const useModalSurvey = () => {
  const isVisibleModalSurvey = readonly(_isVisibleModalSurvey);
  const typeSurvey = readonly(_typeSurvey);

  const openModalSurvey = () => {
    _isVisibleModalSurvey.value = true;
  };

  const closeModalSurvey = () => {
    _isVisibleModalSurvey.value = false;
  };

  const setTypeSurveyUnsubscribe = () => {
    _typeSurvey.value = 'CANCEL_SUBSCRIPTION';
  };

  const setTypeSurveyDeleteAccount = () => {
    _typeSurvey.value = 'DELETE_ACCOUNT';
  };

  return {
    isVisibleModalSurvey,
    typeSurvey,
    openModalSurvey,
    closeModalSurvey,
    setTypeSurveyUnsubscribe,
    setTypeSurveyDeleteAccount,
  };
};
